import { render, staticRenderFns } from "./notifier_detail.vue?vue&type=template&id=1afad0e6&"
import script from "./notifier_detail.vue?vue&type=script&lang=js&"
export * from "./notifier_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports